export default {"src":"/_next/static/media/peak.c84b1ba5.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};